import React, { useState, useEffect } from "react";
import { CiBullhorn } from "react-icons/ci";
import { CSS_CLASSES } from "../../../css-classes";
import {
  showMessage,
  makeAjax,
  url,
  respStatus,
} from "../../../helpers/global_helper";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const News = (props) => {
  const { userProfile } = useSelector((state) => ({
    userProfile: state.playerProfileR?.data ?? {},
  }));
  const InitData = [
    { code: "before_login_message", value: "", name: "Before Login" },
    { code: "after_login_message", value: "", name: "After_Login" },
  ];
  const [dateState, setDateState] = useState(new Date());
  const [runningData, setRunningData] = useState(InitData);
  const [payLoad, setPayLoad] = useState({})
  let loggedIn = window.localStorage.getItem("user_token")
  let langD = window.localStorage.getItem("I18N_LANGUAGE");

  useEffect(() => {
    let getPayload = {};
    if (loggedIn) {
      getPayload['code'] = "after_login_message";
      getPayload['lang_code'] = langD;
    }
    else {
      getPayload['code'] = "before_login_message";
      getPayload['lang_code'] = langD
    }
    setPayLoad(getPayload)
  }, [loggedIn, langD])

  const listTextData = () => {
    makeAjax(url.ADMIN_API.getTextRunningData, payLoad, url.ADMIN_MS_EXT).then(
      (response) => {
        if (response?.status != respStatus["SUCCESS"]) {
          if (response?.code != "validation_error") {
            return;
          }
          showMessage(response);
          return;
        }
        const data = Array.isArray(response.data)
          ? response.data
          : [response.data];
        setRunningData(data);
      }
    );
  };

  useEffect(() => {
    listTextData();
  }, [payLoad])

  useEffect(() => {
    setInterval(() => setDateState(new Date()));
  }, []);

  const date = dateState.toLocaleDateString("en-GB", {
    month: "long",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  });

  const isMessageEmpty =
    runningData.length > 0 &&
    runningData.some(
      (data) =>
        ((data.code === "before_login_message" && loggedIn == null) ||
          (data.code === "after_login_message" && loggedIn != null)) &&
        (!data.value || data.value === "null" || data.value.trim() === "")
    );
  return (
    <div
      className={isMessageEmpty ? "empty_news" : CSS_CLASSES.news}
    >
      <div className="dateandann">
        <span className="date">{date}</span>
        <span className="announcement">
          <CiBullhorn className="icon" />
          <p>{props.t("news")} </p>
        </span>
      </div>

      <div className="moving-text">
        {runningData.length > 0 &&
          runningData.map((data, index) => {
            return (
              <React.Fragment key={index}>
                {data.code === "before_login_message" && loggedIn == null ? (
                  data.value && data.value !== "null" ? (
                    <marquee>
                      <div
                        dangerouslySetInnerHTML={{ __html: data?.value }}
                      ></div>
                    </marquee>
                  ) : null
                ) : data.code === "after_login_message" && loggedIn != null ? (
                  data.value && data.value !== "null" ? (
                    <marquee>
                      <div
                        dangerouslySetInnerHTML={{ __html: data?.value }}
                      ></div>
                    </marquee>
                  ) : null
                ) : null}
              </React.Fragment>
            );
          })}
      </div>
    </div>
  );
};

News.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(News);
